<template>
  <div class="page-detail workorder-detail" v-loading="loading">
    <div class="title">呼叫记录详情</div>
    <div class="content">
      <div class="field">
        <div class="label">坐席名称</div>
        <div class="text">{{ record.agentNames }}</div>
      </div>
      <div class="field">
        <div class="label">开始时间</div>
        <div class="text">
          {{ record.startTime }}
        </div>
      </div>
      <div class="field">
        <div class="label">结束时间</div>
        <div class="text">
          {{ record.endTime }}
        </div>
      </div>
      <div class="field">
        <div class="label">通话开始时间</div>
        <div class="text">
          {{ record.establishedTime }}
        </div>
      </div>
      <div class="field">
        <div class="label">通话结束时间</div>
        <div class="text">
          {{ record.releaseTime }}
        </div>
      </div>
      <div class="field">
        <div class="label">呼叫类型</div>
        <div class="text">
          {{ record.contactType }}
        </div>
      </div>
      <div class="field">
        <div class="label">总时长</div>
        <div class="text">{{ record.callDuration }}秒</div>
      </div>
      <div class="field">
        <div class="label">通话时长</div>
        <div class="text">{{ record.recordingDuration }}秒</div>
      </div>
      <div class="field">
        <div class="label">主叫号码</div>
        <div class="text">{{ record.callingNumber }}</div>
      </div>
      <div class="field">
        <div class="label">被叫号码</div>
        <div class="text">{{ record.calledNumber }}</div>
      </div>
      <div class="field">
        <div class="label">通话录音</div>
        <!-- <audio
          :src="mp3Url[0] + record.feedback.RecordFileName + mp3Url[1]"
          controls="controls"
        >
          Your browser does not support the audio element.
        </audio> -->
        <audio :src="mp3Url" controls="controls">
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import qs from "qs";
import { callRecordApi } from "@/services/all-api.js";

export default {
  data() {
    return {
      dialogVisible: false,
      record: {},
      //   mp3Url: ["http://ftykf.gsftyh.net:9060/recordfiles/", ".mp3"],
      loading: false,
      mp3Url: "",
    };
  },
  mounted() {
    this.record = {};

    let data = JSON.parse(sessionStorage.getItem("recordDetail"));

    this.record = data;
    this.loadAudio(this.record.contactId);
  },
  //   computed: {
  //     gid() {
  //       return this.$route.query.gid;
  //     }
  //   },
  //   watch: {
  //     $route() {
  //       this.loadData();
  //     }
  //   },
  methods: {
    loadAudio(contactId) {
      this.loading = true;
      callRecordApi
        .getAuido({ contactId: contactId })
        .then((res) => {
          this.mp3Url = res.data[0].signatureUrl.replace(/^\"|\"$/g, "");
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadData() {
      if (!this.gid) {
        this.routeBack();
        return;
      }
      this.record = {};
      this.loading = true;
      callRecordApi
        .detail({ gid: this.gid })
        .then((res) => {
          let data = res.data;
          data.feedback = JSON.parse(data.feedback);
          this.record = data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
audio {
  height: 26px;
}
</style>
